import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function UnaffectedOvarianCancer() {
    return ReferralCriteria({
        criteria: [
            (<>A first degree relative with ovarian cancer and one first/second degree relative diagnosed with bowel or breast cancer at younger than age 50 years</>),
            (<>A first degree relative with ovarian cancer and two first/second degree relatives diagnosed with breast cancer at younger than an average age of 60 years</>),
            (<>A first degree relative with ovarian cancer and another ovarian cancer at any age.</>),
            (<>A first degree relative with ovarian cancer and two first/second degree relatives diagnosed with bowel cancer at younger than an average age of 60 years.</>)
        ],
        properties: {
            color: 'purple'
        }
    });
}

export default UnaffectedOvarianCancer;
